<div class="rounded-lg lg:p-2.5 w-full text-center">
  <h1 class="mb-md">Wie kann ich Ihnen helfen?</h1>
  <p class="body-md pb-xl text-content-text-body-primary">Wie kann ich Ihnen helfen? Finden Sie nicht, was Sie suchen? Dieser Chatbot unterstützt Sie bei Ihren Fragen zu unseren Leistungen und Services und hilft Ihnen bei der Suche nach den Infos, die Sie brauchen. Direkt und rund um die Uhr einsatzbereit. </p>
  <div class="mb-md">
    <app-chat-input (submitted)="startChat($event)" />
  </div>
  <span class="body-sm text-content-text-body-secondary">Hier finden Sie die <a class="text-parent" (click)="openTos()">Nutzungsbedingungen der SVS</a>.</span>
</div>
